import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import moment from "moment";
import useOnScreen from "../../Hooks/useOnScreen";
import { readInternalMessage } from "../../Store/Actions/ChatAction";

const Message = ({ message, recipientID }) => {
  // used to make sure handleReadMessage only run once
  const [isRead, setIsRead] = useState(false);

  const { myInfo } = useSelector((state) => state.auth);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);

  const handleReadMessage = () => {
    const payload = {
      messageID: message.id,
      agentID: recipientID,
    };

    readInternalMessage(payload)
      .then((response) => {
        if (response.status) {
          // console.log("Read message", message.id);
        } else {
          console.log("Error read message", response.error);
        }
      })
      .catch((err) => {
        console.log("Error read message", err);
      });

    setIsRead(true);
  };

  /*
    Conditions description:
    - Check if message is visible on screen
    - Check if the message sender is not this user
    - Check if message is already read
  */

  isVisible &&
    message.sender !== myInfo.user.AgentName &&
    !isRead &&
    handleReadMessage();

  return (
    <div
      className={`message ${
        message.sender !== myInfo.user.AgentName ? "received" : "sent"
      }`}
      ref={ref}
    >
      <div className="bubble">
        <p>{message.message}</p>

        <div className="status">
          <p className="time">{moment(message.time).format("HH:mm")}</p>

          {message.sender === myInfo.user.AgentName && (
            <Icon
              color={message.isRead ? "#0343C7" : "#727272"}
              height="20"
              icon="bi:check-all"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Message;
